import { motion } from 'framer-motion';

const FadeIn = ({ children, className = '' }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function PrivacyPage() {
  return (
    <main className="pt-20">
      <section className="py-16 bg-[rgb(17,17,19)] relative">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)', backgroundSize: '32px 32px' }} />
        <div className="max-w-[800px] mx-auto px-6 relative">
          <FadeIn>
            <span className="text-[#F37021] text-sm font-semibold tracking-widest uppercase">Legal</span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mt-3 mb-4">Privacy Policy</h1>
            <p className="text-[rgb(161,161,170)] text-sm">Last updated: August 2025</p>
          </FadeIn>
        </div>
      </section>

      <section className="py-16 bg-[rgb(17,17,19)]">
        <div className="max-w-[800px] mx-auto px-6">
          <FadeIn>
            <div className="prose prose-invert max-w-none space-y-8">
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">1. Information We Collect</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">We collect personal information that you voluntarily provide when you fill out enquiry forms, including your name, email address, phone number, and course interest. We may also collect browsing data through cookies and analytics tools.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">2. How We Use Your Information</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">Your information is used to respond to your enquiries, provide course-related information, send promotional materials (with your consent), improve our services, and personalize your experience on our website.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">3. Data Protection</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">We implement appropriate security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of electronic transmission or storage is 100% secure.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">4. Cookies</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">Our website uses cookies to enhance your browsing experience. You can control cookie settings through your browser. Disabling cookies may affect certain features of our website.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">5. Third-Party Services</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">We may use third-party services such as Google Analytics for website analytics and Google Maps for location services. These services have their own privacy policies governing the use of your information.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">6. Your Rights</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">You have the right to access, update, or delete your personal information. You can also opt out of marketing communications at any time. Contact us at info@scaleupacademy.in for any privacy-related requests.</p>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-white mb-3">7. Contact Us</h2>
                <p className="text-[rgb(218,218,218)] text-sm leading-relaxed">For any questions about this privacy policy, please contact us at info@scaleupacademy.in or call +91 98765 43210.</p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </main>
  );
}
